/// <amd-module name="Artifacts/Root/types/IFeed" />

import {
  AccountMetadata,
  FeedMessage,
  UpstreamSourceIdentifier,
  ViewIdentifier,
} from "Artifacts/Root/types/AzureArtifacts";
import { IFeedIdentity } from "Artifacts/Root/types/IFeedIdentity";
import { FeedPermission } from "Artifacts/Root/web-apis/contracts/Feed";

export interface IFeed extends IFeedIdentity {
  /**
   * Identifying information for the upstream sources of a feed
   */
  upstreamSources: UpstreamSourceIdentifier[];
  /**
   * Identifying information for the views on top of a feed
   */
  views: ViewIdentifier[];
  /**
   * Guid of the currently selected view (if any)
   */
  selectedViewId?: string;
  /**
   * Additional feed metadata
   */
  accountMetadata: AccountMetadata;
  /**
   * int value representing the feed level operation permissions for the current user
   */
  permissionBitMask: number;
  /**
   * Badged enabled in feed
   */
  isBadgesEnabled: boolean;
  /**
   * Messages for the feed
   */
  feedMessages?: FeedMessage[];
  /**
   * Explicit permissions for the feed.
   */
  permissions?: FeedPermission[];
}
